import {GlobalVariables} from "../GlobalVariables";

export default class BlockSeparator {
	static init() {
		document.querySelectorAll(".block-separator").forEach(block => {
			const separator = block.querySelector(".separator");
			let before = separator.querySelector(".before");
			let current = separator.querySelector(".current");
			let after = separator.querySelector(".after");
			document.addEventListener("mousemove", e => {
				const percentage = e.clientX / window.innerWidth;
				const target = Math.round(61 * percentage);

				if (before) {
					before.classList.remove("before");
				}
				current.classList.remove("current");
				if (after) {
					after.classList.remove("after");
				}


				const newCurrent = separator.querySelector(`.line:nth-child(${target})`);
				if (newCurrent) {
					current = newCurrent;
					newCurrent.classList.add("current");
					const newBefore = newCurrent.previousElementSibling;
					if (newBefore) {
						newBefore.classList.add("before");
						before = newBefore;
					}
					const newAfter = newCurrent.nextElementSibling;
					if (newAfter) {
						newAfter.classList.add("after");
						after = newAfter;
					}
				}
			});
		});
	}
}
